import { cloneObject } from '../../../utilities';

const getLegendQuill = (_labelField, _xAxisField, _yAxisField, _fields) => {
  const legendQuill = {
    ops: [
      {
        insert: {
          inlineValue: {
            fieldName: _labelField,
            title: _fields[_labelField].title,
            format: cloneObject(_fields[_labelField].format),
          },
        },
      },
      { insert: '\n' },
    ],
  };
  return legendQuill;
};
export default getLegendQuill;
